import React, {useCallback, useEffect, useState} from "react";
import styles from "./PatientInfo.module.scss";
import {MaleIcon, SaveIcon} from "../../assets";
import InputMask from "react-input-mask";
import {Autocomplete, Input} from "../../ui-components";
import moment from "moment";
import { CUSTOMERSREGIONS} from "../../services/constants";
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {omit} from "lodash";
import {updateCustomerInfoRequests} from "../requests/er-thunk";
import Switcher from "../../ui-components/Switcher";
import {Datepicker, InfoText, Spinner} from "../../shared";

const PatientInfo = ({isEditable, fullHeight = "100%"}) => {
  const dispatch = useAppDispatch()
  const [loader, setLoader] = useState(false)

  const {
    request,
    pool,
    activePanel,
    er_call,
    insurance_org,
    emergency_responsible
  } = useAppSelector(state => state.requests)

  const [updateData, setUpdateData] = useState({
    birthday: moment(request?.birthday).toString(),
    patient_name: request?.patient_name || request?.name,
    contact_number: request.contact_number,
    data: {
      need_hospitalization: request?.data?.need_hospitalization,
      station_info_address: request?.data?.station_info_address,
      station_info: request?.data?.station_info,
    },
    complaints: request.complaints,
    notes: request.notes,
    address: request?.address,
  })

  useEffect(() => {
    setUpdateData({
      birthday: moment(request?.birthday).toString(),
      patient_name: request?.patient_name || request?.name,
      contact_number: request.contact_number,
      data: {
        need_hospitalization: request?.data?.need_hospitalization,
        station_info_address: request?.data?.station_info_address,
        station_info: request?.data?.station_info,
      },
      complaints: request.complaints,
      notes: request.notes,
      address: request?.address,
    })
  }, [request])
  const isValid = (data) => {
    const dataWithoutFoodAndWC = { ...data };
    delete dataWithoutFoodAndWC.need_hospitalization;
    delete dataWithoutFoodAndWC.station_info_address;
    delete dataWithoutFoodAndWC.station_info;
    delete dataWithoutFoodAndWC.notes;
    return Object.keys(dataWithoutFoodAndWC).every((k) => {
      return data[k]
    })
  }
  const handleUpdate = useCallback( () => {
    if (isValid(omit(updateData, ['comment1']))) {
      setLoader(true);
      dispatch(updateCustomerInfoRequests({uuid: request?.uuid, data:updateData})).then(res => {
        // @ts-ignore
        if(res) {
          setTimeout(() => {
            setLoader(false);
            // setAcceptSuccess(true);
          }, 1000); // Delay of 100ms
        }
      })
    } else {
      // setErrorMessage('*Заполните все поля.')
    }
  }, [dispatch, request?.uuid, updateData])

  return <div className={styles.container} style={{height: fullHeight}}>
    <div className={styles.head} >
      <div className={styles.headWrapper} >
        <MaleIcon className='mr-5'/>
        <p>Данные о пациенте</p>
        <div className={styles.title} >{request?.sentry_type}</div>
        {!isEditable && (
          loader ? (
            <Spinner/>
          ) : (
            <SaveIcon style={{ cursor: "pointer" }} onClick={handleUpdate} />
          )
        )}
      </div>
    </div>
    <div className={styles.body}>
      <div className={styles.bodyHeadWrapper} >
        <div style={{width: "44%"}}>
          <Datepicker error={!updateData.birthday}
            // disableDates={new Date().toString()}
                      inputDisabled={isEditable}
                      disableDates={"future"}
                      handleDateChange={(date) => setUpdateData({...updateData, birthday: date})}
                      value={updateData.birthday || new Date().toString()} label={"Дата Рождения"}/>
        </div>
        <Input name='name'
               onChange={(e) => setUpdateData({...updateData, patient_name: e?.target?.value})}
               value={updateData.patient_name}
               error={!updateData.patient_name}
               className={styles.input}
               disabled={isEditable}
               label="Имя"/>
        {/*<InputMask mask="99/99/9999"*/}
        {/*           maskChar=""*/}
        {/*           className={styles.input}*/}
        {/*           name='sentry_date_from'*/}
        {/*           placeholderText='ДД/ММ/ГГГГ'*/}
        {/*           error={!updateData.birthday}*/}
        {/*           onFocus={e => e && e.preventDefault()}*/}
        {/*           onChange={(e) => e && setUpdateData({...updateData, birthday: e?.target?.value})}*/}
        {/*           value={updateData.birthday}*/}
        {/*           disabled={isEditable}*/}
        {/*           label="Дата Рождения">*/}

        {/*  {(inputProps) => <Input disabled={isEditable} {...inputProps} />}*/}
        {/*</InputMask>*/}
      </div>
      {/*<div style={{alignSelf: 'stretch', padding: 12, background: '#F1F6FF', borderRadius: 8, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 4, display: 'inline-flex'}}>*/}
      {/*  <div style={{color: '#192233', fontSize: 12,  fontWeight: 500,  wordWrap: 'break-word'}}>Дата и время завершения: </div>*/}
      {/*  <div style={{flex: '1 1 0', color: '#192233', fontSize: 12,  fontWeight: 500,  wordWrap: 'break-word'}}>{moment(request?.sentry_date_to).format('DD/MM/YYYY HH:mm')}</div>*/}
      {/*</div>*/}
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Autocomplete className={styles.select}
                      options={CUSTOMERSREGIONS}
                      optionLabel={'type'}
                      optionValue={'key'}
                      value={request.city === "Москва" ? 1 : 2}
                      disabled
                      label="Город"/>
        <InputMask mask="+7 (999) 999-99-99" maskChar=" "
                   className={styles.input}
                   name='contact_number'
                   value={request.contact_number}
                   disabled
                   onChange={() => {}}
                   label={"Номер телефона"}>
          {(inputProps) => <Input disabled {...inputProps} />}
        </InputMask>
      </div>
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='inn'
               className={styles.input}
               value={updateData?.address}
               error={!updateData?.address}
               disabled={isEditable}
               onChange={(e) => setUpdateData({...updateData, address: e?.target?.value})}
               label="Адрес  мероприятия"/>
      </div>
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='complaints'
               error={!updateData?.complaints}
               className={styles.input}
               disabled={isEditable}
               value={updateData?.complaints}
               onChange={(e) => setUpdateData({...updateData, complaints: e?.target?.value})}
               label="Жалобы"/>
      </div>
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='notes'
               // error={!updateData?.notes}
               className={styles.input}
               disabled={isEditable}
               value={updateData?.notes}
               onChange={(e) => setUpdateData({...updateData, notes: e?.target?.value})}
               label="Дополнительная информация"/>
      </div>
      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Switcher  disabled={true} defaultChecked={updateData?.data?.need_hospitalization} id={"uniq"}  onChange={() =>
          setUpdateData((prev) => ({
            ...prev,
            data: {
              ...prev.data,
              need_hospitalization: !prev.data?.need_hospitalization,
            },
          }))
        } label=" Запрос госпитализации
" name="need_hospitalization"  />
      </div>

      <div style={{alignSelf: 'stretch', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 16, display: 'inline-flex'}}>
        <Input name='station_info'
               className={styles.input}
               disabled={true}
               value={updateData?.data?.station_info}
               onChange={(e) =>
                 setUpdateData((prev) => ({
                   ...prev,
                   data: {
                     ...prev.data,
                     station_info: e.target.value,
                   },
                 }))
               }

               label="Название стационара"/>
        <Input name='station_info_address'
               className={styles.input}
               disabled={true}
               value={updateData?.data?.station_info_address}
               onChange={(e) =>
                 setUpdateData((prev) => ({
                   ...prev,
                   data: {
                     ...prev.data,
                     station_info_address: e.target.value,
                   },
                 }))
               }
               label="Адрес стационара"/>

      </div>

      {/*<div className={styles.wrapper}>*/}
      {/*  <InfoText className={styles.dcText} title={'Запросить госпитализацю'} text={updateData?.need_hospitalization ? "Да" : "Нет"}/>*/}
      {/*</div>*/}
      {/*{updateData?.need_hospitalization &&*/}
      {/*  <div className={styles.wrapper}>*/}
      {/*    <InfoText className={styles.dcText} title={'Выбор Стационара'} text={updateData?.station_info }/>*/}
      {/*    <InfoText className={styles.dcText} title={'Адрес'} text={updateData?.station_info_address}/>*/}
      {/*  </div>*/}
      {/*}*/}
    </div>
  </div>
}

export default PatientInfo
